var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-gray-light"},[_vm._v(" "+_vm._s(_vm.$t('reservationDetail.tripInfo.ESTIMATED_ARRIVAL'))+" "+_vm._s(_vm.formattedDisplayTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }